import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    interesse: '',
    mensagem: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.nome || !formData.email || !formData.telefone || !formData.interesse) {
      return;
    }

    if (formData.mensagem.length > 500) {
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d69hl6tbd17lru29l9o0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          email: '',
          telefone: '',
          interesse: '',
          mensagem: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contato" className="py-16 sm:py-20 bg-dark-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-12">
          <div className="lg:col-span-3">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">Entre em Contato</h2>
            <p className="text-gray-400 mb-8">
              Preencha o formulário e retornarei em até 24 horas
            </p>

            <form id="contact-form" onSubmit={handleSubmit} data-readdy-form className="space-y-4 sm:space-y-5">
              <div>
                <input
                  type="text"
                  name="nome"
                  value={formData.nome}
                  onChange={handleChange}
                  placeholder="Nome completo *"
                  required
                  className="w-full px-5 sm:px-6 py-3 sm:py-4 bg-dark-800 border border-dark-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm text-white placeholder-gray-500"
                />
              </div>

              <div>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email *"
                  required
                  className="w-full px-5 sm:px-6 py-3 sm:py-4 bg-dark-800 border border-dark-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm text-white placeholder-gray-500"
                />
              </div>

              <div>
                <input
                  type="tel"
                  name="telefone"
                  value={formData.telefone}
                  onChange={handleChange}
                  placeholder="Telefone/WhatsApp *"
                  required
                  className="w-full px-5 sm:px-6 py-3 sm:py-4 bg-dark-800 border border-dark-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm text-white placeholder-gray-500"
                />
              </div>

              <div>
                <select
                  name="interesse"
                  value={formData.interesse}
                  onChange={handleChange}
                  required
                  className="w-full px-5 sm:px-6 py-3 sm:py-4 bg-dark-800 border border-dark-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm text-white"
                >
                  <option value="" className="text-gray-500">Selecione seu interesse *</option>
                  <option value="Agentes de IA">Agentes de IA</option>
                  <option value="Criação de Sites">Criação de Sites</option>
                  <option value="Neuro Agents">Neuro Agents Global AI</option>
                  <option value="Consultoria Geral">Consultoria Geral</option>
                </select>
              </div>

              <div>
                <textarea
                  name="mensagem"
                  value={formData.mensagem}
                  onChange={handleChange}
                  placeholder="Mensagem (máximo 500 caracteres)"
                  maxLength={500}
                  rows={5}
                  className="w-full px-5 sm:px-6 py-3 sm:py-4 bg-dark-800 border border-dark-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent resize-none text-sm text-white placeholder-gray-500"
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">{formData.mensagem.length}/500 caracteres</p>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white py-3 sm:py-4 rounded-lg font-semibold transition-all cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed shadow-lg shadow-red-900/30"
              >
                {isSubmitting ? 'ENVIANDO...' : 'ENVIAR MENSAGEM'}
              </button>

              {submitStatus === 'success' && (
                <div className="bg-green-900/30 border border-green-600/30 text-green-400 px-4 py-3 rounded-lg text-sm">
                  Mensagem enviada com sucesso! Retornarei em breve.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-900/30 border border-red-600/30 text-red-400 px-4 py-3 rounded-lg text-sm">
                  Erro ao enviar mensagem. Tente novamente.
                </div>
              )}

              <p className="text-xs text-gray-500 flex items-center">
                <i className="ri-lock-line mr-2"></i>
                Seus dados estão protegidos
              </p>
            </form>
          </div>

          <div className="lg:col-span-2 space-y-4">
            <a 
              href="https://wa.me/5541992584018"
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-dark-800 rounded-xl p-5 sm:p-6 border border-dark-600 hover:border-green-600/50 transition-all cursor-pointer group"
            >
              <div className="flex items-center">
                <div className="w-11 h-11 sm:w-12 sm:h-12 bg-green-600/20 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-whatsapp-line text-xl sm:text-2xl text-green-500"></i>
                </div>
                <div>
                  <p className="text-sm text-gray-500">WhatsApp</p>
                  <p className="font-semibold text-white group-hover:text-green-400 transition-colors">(41) 99258-4018</p>
                </div>
              </div>
            </a>

            <a 
              href="https://instagram.com/neuroagentsglobal"
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-dark-800 rounded-xl p-5 sm:p-6 border border-dark-600 hover:border-pink-600/50 transition-all cursor-pointer group"
            >
              <div className="flex items-center">
                <div className="w-11 h-11 sm:w-12 sm:h-12 bg-gradient-to-br from-pink-600/20 to-red-600/20 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-instagram-line text-xl sm:text-2xl text-pink-500"></i>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Instagram</p>
                  <p className="font-semibold text-white group-hover:text-pink-400 transition-colors">@neuroagentsglobal</p>
                </div>
              </div>
            </a>

            <div className="bg-dark-800 rounded-xl p-5 sm:p-6 border border-dark-600">
              <div className="flex items-center">
                <div className="w-11 h-11 sm:w-12 sm:h-12 bg-red-600/20 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-time-line text-xl sm:text-2xl text-red-500"></i>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Horário</p>
                  <p className="font-semibold text-white">Seg - Sex: 9h às 18h</p>
                </div>
              </div>
            </div>

            <div className="pt-4 sm:pt-6">
              <p className="text-sm text-gray-500 mb-4">Conecte-se comigo:</p>
              <div className="flex space-x-4">
                <a 
                  href="https://instagram.com/neuroagentsglobal" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-11 h-11 sm:w-12 sm:h-12 bg-dark-700 hover:bg-gradient-to-br hover:from-pink-600 hover:to-red-600 border border-dark-600 hover:border-transparent rounded-full flex items-center justify-center transition-all cursor-pointer group"
                >
                  <i className="ri-instagram-line text-xl text-gray-400 group-hover:text-white"></i>
                </a>
                <a 
                  href="https://wa.me/5541992584018" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="w-11 h-11 sm:w-12 sm:h-12 bg-dark-700 hover:bg-green-600 border border-dark-600 hover:border-transparent rounded-full flex items-center justify-center transition-all cursor-pointer group"
                >
                  <i className="ri-whatsapp-line text-xl text-gray-400 group-hover:text-white"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
